export const pathsWithoutIndexComponent = []
